const translations = {
    flightControllerSerialConflict:
        'A drone already exists with this flight controller serial number.',
    save: 'Save Aircraft',
    saveError: 'Something went wrong. Please try again.',
    title: 'Add Aircraft'
};

export default translations;
